/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_wf_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Free word frequency counter. See which words appear most often in your text, ranked with counts and bars. Runs in your browser.`)
};

const es_wf_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contador de frecuencia de palabras gratuito. Ve qué palabras aparecen más a menudo en tu texto, ordenadas con conteos y barras. Se ejecuta en tu navegador.`)
};

const de_wf_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kostenloser Wortfrequenzzähler. Sehen Sie, welche Wörter in Ihrem Text am häufigsten vorkommen, sortiert mit Anzahl und Balken. Läuft direkt in Ihrem Browser.`)
};

const nl_wf_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratis woordfrequentieteller. Zie welke woorden het meest voorkomen in uw tekst, gerangschikt met aantallen en balken. Werkt in uw browser.`)
};

const fr_wf_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compteur de fréquence des mots gratuit. Voyez quels mots apparaissent le plus souvent dans votre texte, classés avec des compteurs et des barres. S'exécute dans votre navigateur.`)
};

const it_wf_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contatore di frequenza delle parole gratuito. Vedi quali parole appaiono più spesso nel tuo testo, classificate con conteggi e barre. Funziona nel tuo browser.`)
};

const pt_br2_wf_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contador de frequência de palavras gratuito. Veja quais palavras aparecem com mais frequência no seu texto, classificadas com contagens e barras. É executado no seu navegador.`)
};

const pt_wf_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contador de frequência de palavras gratuito. Veja quais palavras aparecem mais vezes no seu texto, classificadas com contagens e barras. Funciona no seu navegador.`)
};

const ja_wf_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`無料の単語頻度カウンター。テキストに最も頻繁に出現する単語を確認し、カウント数とバーでランク付けされています。ブラウザで実行されます。`)
};

const zh_wf_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`免费的词频统计工具。查看文本中出现频率最高的单词，并以计数和条形图排名显示。在你的浏览器中运行。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const wf_tool_description = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.wf_tool_description(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("wf_tool_description", locale)
	if (locale === "en") return en_wf_tool_description(inputs)
	if (locale === "es") return es_wf_tool_description(inputs)
	if (locale === "de") return de_wf_tool_description(inputs)
	if (locale === "nl") return nl_wf_tool_description(inputs)
	if (locale === "fr") return fr_wf_tool_description(inputs)
	if (locale === "it") return it_wf_tool_description(inputs)
	if (locale === "pt-BR") return pt_br2_wf_tool_description(inputs)
	if (locale === "pt") return pt_wf_tool_description(inputs)
	if (locale === "ja") return ja_wf_tool_description(inputs)
	return zh_wf_tool_description(inputs)
};